import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { ToastProvider } from './components/Toast'
import { AuthGate } from './components/AuthGate'
import './styles.css'
import './fixes.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider><AuthGate><App /></AuthGate></ToastProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
